import omitBy from "lodash/omitBy";
import { createContext } from "react";
import { Theme } from "react-select";

// const cssVariables: TAppColors = {
//   primary: "#06BBCC",
//   secondary: "#6c757d",
// } as TAppColors;

import cssVariables from "styles/variables.module.scss";

export const STPI_CITIES = [
  "Agartala",
  "Aizawl",
  "Aurangabad",
  "Berhampur",
  "Bhilai",
  "Bhopal",
  "Coimbatore",
  "Davanagere",
  "Dehradun",
  "Deoghar",
  "Durgapur",
  "Gangtok",
  "Goa",
  "Gwalior",
  "Haldia",
  "Hubballi",
  "Imphal",
  "Indore",
  "Jaipur",
  "Jammu",
  "Jodhpur",
  "Kakinada",
  "Kanpur",
  "Kharagpur",
  "Kohima",
  "Kolhapur",
  "Lucknow",
  "Madurai",
  "Mangaluru",
  "Manipal",
  "Meerut",
  "Mohali",
  "Mysuru",
  "Nagpur",
  "Nasik",
  "Navi Mumbai",
  "Patna",
  "Prayagraj",
  "Puducherry",
  "Ranchi",
  "Rourkela",
  "Shillong",
  "Shimla",
  "Siliguri",
  "Srinagar",
  "Surat",
  "Tirunelveli",
  "Tirupati",
  "Trichy",
  "Vijayawada",
  "Visakhapatnam",
  "Warangal",
];

export const CENTER_NAMES = [
  "Agartala Indranagar",
  "Agartala Lichubagan",
  "Agra - Upcoming",
  "Aizawl",
  "Amritsar",
  "Aurangabad",
  "Bengaluru",
  "Berhampur",
  "Bhilai (Mangal Bhawan)",
  "Bhilai (Junwnai Road)",
  "Bhopal",
  "Bhubaneswar",
  "Chennai",
  "Davanagere",
  "Dehradun",
  "Dehradun IT Park",
  "Deoghar",
  "Durgapur",
  "Gandhinagar",
  "Gangtok",
  "Goa",
  "Gurugram",
  "Guwahati",
  "Gwalior",
  "Haldia",
  "Hubballi",
  "Hyderabad Cyber towers",
  "Hyderabad Solitaire Building",
  "Imphal",
  "Indore",
  "Jaipur",
  "Jaipur",
  "Jammu",
  "Jodhpur",
  "Kakinada",
  "Kanpur",
  "Kharagpur",
  "Kohima",
  "Kolhapur",
  "Kolkata",
  "Lucknow",
  "Mangaluru",
  "Meerut",
  "Mohali",
  "Mohali",
  "Nashik",
  "Navi Mumbai",
  "Noida",
  "Patna",
  "Prayagraj",
  "Pune Bhosari",
  "Pune Hinjawadi",
  "Pune Magarpatta",
  "Ranchi",
  "Ranchi Sahkarita Bhawan",
  "Rourkela",
  "Shillong",
  "Shimla Boileauganj",
  "Shimla Kasumpti",
  "Siliguri",
  "Srinagar",
  "Surat",
  "Tirupati",
  "Vijaywada",
  "Vijaywada Vincity",
  "Warangal",
];

export const CENTER_IMAGES_SRC = [
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Agarta_Inc_2.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Agarta_Inc_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/WhatsApp%20Image%202022-08-08%20at%207.36.47%20PM.jpeg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Aizawl.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/amritsar_inc_1_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/totalspacebackground_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/3.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/1.jpeg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Bhilai_Inc.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_7.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/bhopal-incubation.png",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Co-Working%20Space_1_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Chennai_technest.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation-Davanagere-1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/dehradun3.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/dehradun1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/WhatsApp%20Image%202021-01-01%20at%2016.04.30.jpeg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/durgapur1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Main_0_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Gangtok_inc_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_6.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation-gurugram-3.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Guwahati_inc_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/GWAL1280.566_incubation.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/haldia1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI%20HBL%20Incubation%20Workarea-3-1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/hitechcity.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Hyd_inc_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Imphal_Inc_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/indore_incubation.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/DSC01846_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Jaipur_Incubation_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Jammu%20Centre%201280x566.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI%20Building%20%281%29.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI%20Kakinada%20Building_image%201%20-%20inc.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/totalspacebackground_6.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/khragpur_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_kohima_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_5.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation%20Inner%20page_5.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Webp.net-resizeimage.png",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/IMG-20210326-WA0002.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI-Meerut-IncubationCenter2_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/mohali_incubation_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/mohali_incubation_1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_3.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_4.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation-Noida-pics1280x566.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/1_0_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/PNP%20seat.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_2.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/incubation_plug.png",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Picture1%20%281%29.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Shillong_inc1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI_Shimla%20.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/STPI_Shimla%20_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Siliguri1.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/New%20Picture.png",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Building%201_0.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/tirupati_inc.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Vijayawada2.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/1A.jpg",
  "https://stpi.in/sites/default/files/styles/medium/public/incubation-services-images/Incubation_Inner_page_img_1.jpg",
];
function isColorLight(inputColor: string) {
  let color: any = inputColor;
  let r, g, b;
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  return hsp > 127.5;
}
export function changeColorShade(color: string, amount: number) {
  // #FFF not supportet rather use #FFFFFF
  const clamp = (val: number) => Math.min(Math.max(val, 0), 0xff);
  const fill = (str: string) => ("00" + str).slice(-2);

  const num = parseInt(color.substr(1), 16);
  const red = clamp((num >> 16) + amount);
  const green = clamp(((num >> 8) & 0x00ff) + amount);
  const blue = clamp((num & 0x0000ff) + amount);
  return (
    "#" +
    fill(red.toString(16)) +
    fill(green.toString(16)) +
    fill(blue.toString(16))
  );
}

export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = "http://164.164.127.34/icb/api";
export const APP_URL = process.env.REACT_APP_APP_URL;
export const REACT_APP_APP_URL = "http://164.164.127.34/icb"

export const RANDOM_COLORS_LIST = [
  "#a0e3b7",
  "#a25264",
  "#a3d71e",
  "#513886",
  "#dfccfa",
  "#22695e",
  "#967ff2",
  "#32e195",
  "#e5196a",
  "#68c3ef",
  "#a61d99",
  "#5df23e",
  "#e26df8",
  "#459521",
  "#b94414",
  "#ebaa8c",
  "#7129ed",
  "#d6c951",
  "#544437",
  "#f79302",
  "#1d7bc3",
  "#fe2b1c",
];

export const RANDOM_COLORS_LIST_LIGHT = RANDOM_COLORS_LIST.filter((color) =>
  isColorLight(color)
);
export const RANDOM_COLORS_LIST_DARK = RANDOM_COLORS_LIST.filter(
  (color) => !isColorLight(color)
);

export const getRandomColor = (idx: number, light?: boolean) => {
  let availableColors = RANDOM_COLORS_LIST;
  if (light === undefined) {
    availableColors = RANDOM_COLORS_LIST;
  } else if (light) {
    availableColors = RANDOM_COLORS_LIST_LIGHT;
  } else {
    availableColors = RANDOM_COLORS_LIST_DARK;
  }
  return availableColors[idx % availableColors.length];
};

export const removeFalsyValues = (dict: { [key: string]: any }) =>
  omitBy(dict, (item) => !item);

export const isDev = !!process.env.REACT_APP_IS_DEV;

export type loggerFunction = (message?: any, ...optionalParams: any[]) => void;
export type TLogger = { log: loggerFunction; error: loggerFunction };

export const logger: TLogger = {
  log: console.log,
  error: console.error,
};

if (!isDev) {
  logger.log = () => {};
  logger.error = () => {};
}

export const getFormData = (object: { [x: string]: string | Blob }) =>
  Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());

export const rupeesFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
}).format;

type TAppColors = {
  primary: string;
  secondary: string;
  // light: string;
  // dark: string;
  primaryLight: string;
  secondaryLight: string;
  success: string;
  // text: string;
};

export const AppColors: TAppColors = {
  ...cssVariables,
  primaryLight: changeColorShade(cssVariables.primary, 100),
  secondaryLight: changeColorShade(cssVariables.secondary, 100),
} as TAppColors;

export const MobileNumberRegex = new RegExp("[1-9]{1}[0-9]{9}");

export const CardPlaceholder = "/placeholders/Cabin.jpg"
export const CenterPlaceholder = "/placeholder.png";
export const CenterPlaceholderSingle = "/placeholders/Gandhinagar.jpg";
export const CentersPlaceholderImages = [
  "/placeholders/Bhilai.jpg",
  "/placeholders/Surat.jpg",
  "/placeholders/Gandhinagar.jpg",
  
]
export const BuildingPlaceholder = "/placeholder.png";
// export const CenterPlaceholder = "/center-placeholder.webp";
// export const BuildingPlaceholder = "/center-placeholder.webp";

export const HookFormValidations = {
  mobileNumber: {
    minLength: {
      value: 10,
      message: "Must be 10 Digits",
    },
    maxLength: {
      value: 10,
      message: "Must be 10 Digits",
    },
    pattern: {
      value: MobileNumberRegex,
      message: "Must contain digits only",
    },
    setValueAs: (v: string) => {
      let curr = v.replace(/[^\d]+/g, "").slice(0, 10);
      if (curr.startsWith("0")) return curr.slice(1);
      return curr;
    },
  },
};

export const ReactSelectTheme = (theme: Theme) => {
  // console.log(theme);
  return {
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      primary: AppColors.primary,
      primary75: changeColorShade(AppColors.primary, 50),
      primary50: changeColorShade(AppColors.primary, 100),
      primary25: changeColorShade(AppColors.primary, 200),
    },
  };
};

export const scrollWithOffset = (el: any) => {
  // console.log(el);
  const yCoordinate = el.getBoundingClientRect().top + window.scrollY;
  const yOffset = -90;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};

export const ShowAnchorsContext = createContext(false);

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const DisclaimerTexts = {
  spaceAvailablityTariff:
    "Space availability & tariff (Basic + Maintenance) are subject to change without prior notice. Applicable taxes extra.",
  facilityAmenity: "Actual Facilities and Amenities may vary.",
  icorrectOrOutdatedInfo:
    "Actual information may vary; users are advised to contact the respective centers for latest information.",
  spaceAllotment:
    "Submission of an application does not constitute a guarantee of space/seats allocation. STPI reserves the explicit right to allocate fewer spaces or none at all, dependent upon a variety of factors and considerations, without assuming any liability",
  finalPricing:
    "Tentative/expected pricing is provided for estimation purposes; final billing amount may vary. Applicable taxes extra.",
};

export const ErrorMessages = {
  Required: "Mandatory",
};

export function splitArrayIntoGroups<T>(
  inputArray: T[],
  takeNext: number[]
): T[][] {
  if (takeNext.length === 0) return [inputArray];
  return [
    inputArray.slice(0, takeNext.at(0)),
    ...splitArrayIntoGroups(
      inputArray.slice(takeNext.at(0)),
      takeNext.slice(1)
    ),
  ];
}

export const FOUND = "FOUND";
export const NOT_FOUND = "NOT_FOUND";
export const LOADING = "LOADING";
